<div class="navbar-area fixed-top">

    <div class="mobile-nav">
        <a routerLink="/" class="logo">
            <img src="assets/img/logo.png" alt="Logo">
        </a>
    </div>

    <div class="main-nav">
        <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/" style="padding: 0px;">
                    <img src="assets/img/logo/logo.png" alt="Logo">
                    <img src="assets/img/logo/logo-text.png" alt="Logo">
                </a>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a [routerLink]="routesUrl.homeUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home</a>
                        </li>

                        <li class="nav-item"><a [routerLink]="routesUrl.aboutUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">About</a></li>

                        <li class="nav-item"><a [routerLink]="routesUrl.clientsUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Our Valuable Clients</a></li>

                        <li class="nav-item"><a [routerLink]="routesUrl.attorneyUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Attorneys</a></li>

                        <li class="nav-item">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle">More</a>

                            <ul class="dropdown-menu">
                                <li class="nav-item"><a [routerLink]="routesUrl.practiceUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Practice Areas</a></li>

                                <li class="nav-item"><a [routerLink]="routesUrl.practiceDetailsUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Practice Areas Details</a></li>

                                <li class="nav-item"><a [routerLink]="routesUrl.galleryUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Gallery</a></li>

                                <li class="nav-item"><a [routerLink]="routesUrl.privacyPolicyUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Privacy Policy</a></li>
                            </ul>
                        </li>

                        <li class="nav-item"><a [routerLink]="routesUrl.contactUrl" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Contact</a></li>
                    </ul>

                    <div class="side-nav">
                        <a [routerLink]="routesUrl.contactUrl">Get Appointment</a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>